import { render, staticRenderFns } from "./MentionTooltip.vue?vue&type=template&id=286d5ba6&"
import script from "./MentionTooltip.vue?vue&type=script&lang=js&"
export * from "./MentionTooltip.vue?vue&type=script&lang=js&"
import style0 from "./MentionTooltip.vue?vue&type=style&index=0&id=286d5ba6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports